require('./emitedTransfersSummary.scss');

// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const PropTypes = require('prop-types');

// @ helpers
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;

// @ commons
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { LastMovementsTable } = require('commonsComponents/lastMovementsTable');
const { OKLink } = require('commonsComponents/OKLink');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { EmptyState } = require('commonsComponents/emptyState');

// @ components
const EmitedTransfersSummaryTableRow = require('components/transfers/emited/emitedTransfers/emitedTransfersContent/emitedTransfersContentTableRow/emitedTransfersContentTableRow');
const DropdownAccounts = require('components/dropdownAccounts/dropdownAccounts');
const { EmitedTransfersContentTableInfoRow } = require('components/transfers/emited/emitedTransfers/emitedTransfersContent/emitedTransfersContentTableInfoRow/emitedTransfersContentTableInfoRow');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @ utilities
const { contactCenterClassName, conditionalClassName} = require('utilities/conditionals/conditionalClassname');

// @ actions
const intervenersActions = require('actions/getAccountInterveners');

// @ constants
const { TRANSFERS_LANDING_LIMIT } = require('constants/index');
const { LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY } = require('constants/commonsComponents');
const language = getLanguage();


class EmitedTransfersSummary extends React.Component {
    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleAccountChange = this.handleAccountChange.bind(this);
        this.handleRowClick = this.handleRowClick.bind(this);

        const { immAccounts } = props;

        this.state = {
            accountId: immAccounts.getIn(['byId', immAccounts.getIn(['byOrder', 0]), 'accountId']),
            expandedRowId: '',
        }
    }

    componentDidMount() {
        const {
            requestEmitedTransfers,
            requestInterveners
        } = this.props;
        const { accountId } = this.state;
        requestEmitedTransfers(accountId);
        requestInterveners(accountId);
    }

    componentWillUnmount() {
        const { resetInterveners } = this.props;
        const { accountId } = this.state;
        resetInterveners(accountId);
    }

    handleAccountChange(accountId) {
        const {
            requestEmitedTransfers,
            requestInterveners,
            resetInterveners
        } = this.props;
        requestInterveners(accountId);
        resetInterveners(this.state.accountId);
        requestEmitedTransfers(accountId);
        this.setState({
            accountId
        });
    }

    handleRowClick(rowId) {
        this.setState({
            expandedRowId: rowId === this.state.expandedRowId ? '' : rowId
        });
    }

    buildTableHead() {
        const { immScreen } = this.props;

        let tableHead;

        if (immScreen.get('isMobile')) {
            tableHead = (
                <thead>
                    <OKTableRow asHeader className="emited-transfers-summary__table-header-row-line">
                        <OKTableCell
                            asHeader
                            className="emited-transfers-summary__table-header-cell-line"
                            colSpan={3}
                        />
                    </OKTableRow>
                </thead>
            );
        } else {
            const emitedDateClass = conditionalClassName( 'emited-transfers-summary__padding-right-webapp', 'emited-transfers-summary__table-header-cell--date');
            const emitedBeneficiaryClass = conditionalClassName( 'emited-transfers-summary__padding-right-webapp', 'emited-transfers-summary__table-header-cell--beneficiary');
            const emitedAmountClass = contactCenterClassName('emited-transfers-summary__table-header-cell--amount', 'emited-transfers-content-table__header-cell--amount');

            tableHead = (
                <thead>
                    <OKTableRow asHeader>
                        <OKTableCell
                            asHeader
                            className="emited-transfers-content-table__header-cell"
                        />
                        <OKTableCell asHeader className={emitedDateClass}>
                            <FormattedText
                                value="transfersEmitted-dateTwoLines"
                                format="uppercase"
                            />
                        </OKTableCell>
                        <OKTableCell asHeader className={emitedBeneficiaryClass}>
                            <FormattedText
                                value="transfersLanding-beneficiary"
                                format="uppercase"
                            />
                        </OKTableCell>
                        <OKTableCell asHeader>
                            <FormattedText
                                value="transfersLanding-conceptTwoLines"
                                format="uppercase"
                            />
                        </OKTableCell>
                        <OKTableCell asHeader className={emitedAmountClass}>
                            <FormattedText
                                value="transfersLanding-amount"
                                format="uppercase"
                            />
                        </OKTableCell>
                        <OKTableCell asHeader />
                    </OKTableRow>
                </thead>
            );
        }

        return tableHead;
    }

    render() {
        const { immAccounts, immEmitedTransfers, isInactiveAccountsEnabled, immScreen } = this.props;
        const { accountId } = this.state;
        const immAccountEmitedTransfers = immEmitedTransfers.get(accountId);
        const accountsIndexes = immAccounts.get('byOrder').toJS();
        const emitedTransfersLink = `/myprofile/transfers/emited/${accountId}`;
        const headerTitle = formatText('transfersLanding-emitedTranfers');
        const tableHead = this.buildTableHead();
        const columnsCount = immScreen.get('isMobile') ? 3 : 7;

        let table;
        let nextPageButton;

        if (immAccountEmitedTransfers) {
            const isEmpty = immAccountEmitedTransfers.get('byOrder').size === 0;
            if (immAccountEmitedTransfers.get('loading')) {
                table = <LoadingSection />;
            } else if (isEmpty) {
                table = (
                    <EmptyState primaryText={formatText('transfersLanding-noEmitedTransfers')} iconType="transfer-banking"/>
                );
            } else if (immAccountEmitedTransfers.get('byOrder').size > 0) {
                const immAccountEmitedTransfersByOrder = immAccountEmitedTransfers.get('byOrder');
                const immAccountEmitedTransfersById = immAccountEmitedTransfers.get('byId');
                const size = immAccountEmitedTransfersByOrder.size;
                const transactionsCount = Math.min(size, TRANSFERS_LANDING_LIMIT);
                const { expandedRowId } = this.state;

                if (transactionsCount < size) {
                    nextPageButton = (
                        <footer className="text-right emited-transfers-summary__more-button-container">
                            <OKLink modifier="complementary" to={emitedTransfersLink}>
                                <FormattedText
                                    value="transfersLanding-seeMore"
                                />
                            </OKLink>
                        </footer>
                    );
                }

                table = (
                    <LastMovementsTable
                        groupByDate={false}
                        rowComponent={EmitedTransfersSummaryTableRow}
                        immTransactionsByOrder={immAccountEmitedTransfersByOrder.take(
                            transactionsCount
                        )}
                        immTransactionsById={immAccountEmitedTransfersById}
                        columnsCount={columnsCount}
                        id="emited-transfers-summary-table"
                        expandedRowId={expandedRowId}
                        expandedRowComponent={EmitedTransfersContentTableInfoRow}
                        onRowClick={this.handleRowClick}
                        currentMonthKey={LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY}
                        language={language}
                    >
                        {tableHead}
                    </LastMovementsTable>
                );
            }
        }
        const tooltipElement = isInactiveAccountsEnabled ? (
            <div className="emited-transfers-summary__tooltip">
                <OKTooltip
                    content="inactiveAccounts-inactiveAccounts_consultiveDropdownCommonToolTip"
                    offset={[0, -15]}
                />
            </div>
        ) : '';
        return (
            <article className="emited-transfers-summary">
                <header>
                    <div className="emited-transfers-summary__title">
                        <OKBoxTitle value={headerTitle} to={emitedTransfersLink} />
                    </div>
                    <div className="row emited-transfers-summary__main-account">
                        <div className="col-xs-7-cc-11">
                            <DropdownAccounts
                                immAccounts={immAccounts.get('byId')}
                                accountsIndexes={accountsIndexes}
                                currentAccountId={accountId}
                                onAccountChange={this.handleAccountChange}
                                showAvailableBalance
                            />
                        </div>
                        {tooltipElement}
                    </div>
                </header>
                <section>
                    {table}
                </section>
                {nextPageButton}
            </article>
        );
    }
}

EmitedTransfersSummary.propTypes = {
    immAccounts: PropTypes.object.isRequired,
    immEmitedTransfers: PropTypes.object.isRequired,
    immScreen: PropTypes.object.isRequired,
    isInactiveAccountsEnabled: PropTypes.bool.isRequired,
    requestEmitedTransfers: PropTypes.func.isRequired,
    requestInterveners: PropTypes.func.isRequired,
    resetInterveners: PropTypes.func.isRequired
};

module.exports.constructor = EmitedTransfersSummary;
module.exports.EmitedTransfersSummary = connect(null, {
    requestInterveners: intervenersActions.requestAccountInterveners,
    resetInterveners: intervenersActions.resetAccountInterveners
})(EmitedTransfersSummary);
